import { defineStore } from "pinia";
import axiosInstance from "../config/axios";

export const useBiddingStore = defineStore("bidding", {
    state: () => {
        return {
            categories: [],
            categoryBiddingData: [],
            companyAssociateData: [],
            categoryBiddingDataLoading: false,
            productBiddingData: [],
            productBiddingDataLoading: false,
        };
    },
    getters: {},
    actions: {
        async fetchCategoriesBidding({ shopId, data }) {
            return axiosInstance
                .get(`/v1/biddingV2/categories-biddings/${shopId}`, { params: data })
                .then((response) => {
                    this.categoryBiddingData = response.data;
                });
        },
        async fetchCompanyAssociates({shopId}) {
            return axiosInstance
            .get(`/v1/biddingV2/company-associates-bidding/${shopId}`)
            .then((response) => {
                this.companyAssociateData = response.data;
            });
        },
        async fetchProductBidding({ shopId, data }) {
            return axiosInstance
                .get(`/v1/biddingV2/products-biddings/${shopId}`, { params: data })
                .then((response) => {
                    this.productBiddingData = response.data;
                });
        },
        async placeCategoryBidding({ shopId, data }) {
            return axiosInstance.post(`/v1/biddingV2/place-category-bidding/${shopId}`, data).then((response) => {
                return response;
            });
        },
        async updateBid({ bidId, data }) {
            return axiosInstance.put(`/v1/biddingV2/update-bid/${bidId}`, data).then((response) => {
                return response;
            });
        },
        async deleteBid(bidId) {
            return axiosInstance.delete(`/v1/biddingV2/delete-bid/${bidId}`).then((response) => {
                return response;
            });
        },
        async fetchCategoryProjection({ shopId, data }) {
            return axiosInstance
                .get(`/v1/biddingV2/category-bid-projection/${shopId}`, { params: data })
                .then((response) => {
                    return response;
                });
        },
        async fetchCategoryIdealProjection({ shopId, data }) {
            return axiosInstance
                .get(`/v1/biddingV2/ideal-category-bid-projection/${shopId}`, { params: data })
                .then((response) => {
                    return response;
                });
        },
        async fetchCategories({ shopId }) {
            return axiosInstance.get(`/v1/biddingV2/categories/${shopId}`).then((response) => {
                this.categories = response.data;
            });
        },
        async updateOrCreateBids({ shopId, data }) {
            return axiosInstance.post(`/v1/biddingV2/update-create-bids/${shopId}`, data).then((response) => {
                return response;
            });
        },
        async updateCreateBidsAllCategories({ shopId, data }) {
            return axiosInstance
                .post(`/v1/biddingV2/update-create-bids-all-categories/${shopId}`, data)
                .then((response) => {
                    return response;
                });
        },
        async disableEnableBid({ shopId, data }) {
            return axiosInstance.post(`/v1/biddingV2/disable-enable-bid/${shopId}`, data).then((response) => {
                return response;
            });
        },
        async disableEnableBids({ shopId, data }) {
            return axiosInstance.post(`/v1/biddingV2/disable-enable-bids/${shopId}`, data).then((response) => {
                return response;
            });
        },
    },
});
